<template>
  <div class="wrapper theme--large-padding">
      <header class="header" role="banner">
          <div class="header-logo">
              <a href="https://duo.nl" title="Logo Dienst Uitvoering Onderwijs">
                    <span class="header-logo__brand beeldmerk"></span>
                    <span class="header-logo__text header-logo__text--medium duo-text-m"></span>
                    <span class="header-logo__text header-logo__text--small duo-text-s"></span>
                    <span class="screenreader-only">naar de homepagina</span>
                </a>
          </div>
      </header>
      
      <router-view/>

      <footer class="footer">
          <div class="footer__content background--donkergeel">
              <div class="container">
                  <div class="row">
                      <div class="col-xs-12 col-md-10 col-md-offset-1">
                          <span class="footer__header footer__header--title">Samen maken we onderwijs en ontwikkeling mogelijk</span>
                      </div>
                  </div>
              </div>
          </div>
      </footer>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
      name: "app",
      computed: {
          ...mapGetters(['labels'])
      }
  }
</script>
<style>
  @import "~@/styles/osa-only-icons.scss";
  @import "~@/styles/custom.scss";

  html {
      background-color: rgb(235, 235, 235);
  }
</style>
